package com.anjuros.website.templates.template9.components

import org.jetbrains.compose.web.dom.Span
import com.anjuros.website.components.language.ResKey as PlaceholderResKey
import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.components.shared.AnjurosText
import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.templates.template9.modules.Template9FAQ
import com.anjuros.website.templates.template9.modules.Template9Review
import com.anjuros.website.templates.template9.modules.Template9Service
import com.anjuros.website.templates.template9.modules.Template9Theme
import com.anjuros.website.templates.template9.modules.getColor
import com.anjuros.website.templates.template9.styles.TEMPLATE9_ARCH
import com.anjuros.website.templates.template9.styles.Template9CardStyle
import com.anjuros.website.templates.template9.styles.Template9ImageZoomStyle
import com.anjuros.website.templates.template9.styles.template9Blob
import com.anjuros.website.templates.template9.util.Template9Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text


/** Round coloured badge holding a white icon (services, about features). */
@Composable
fun Template9IconBadge(
    icon: String,
    alt: String,
    modifier: Modifier = Modifier,
    accent: Boolean = false,
    size: Int = 56,
    iconSize: Int = 28
) {
    Box(
        modifier = modifier
            .size(size.px)
            .borderRadius(50.percent)
            .backgroundColor(if (accent) Template9Theme.Accent.rgb else Template9Theme.Primary.getColor())
            .border(width = 4.px, style = LineStyle.Solid, color = Template9Theme.Background.rgb),
        contentAlignment = Alignment.Center
    ) {
        AnjurosIcon(
            modifier = Modifier.size(iconSize.px),
            src = icon,
            alt = alt
        )
    }
}

@Composable
fun Template9ServiceCard(service: Template9Service) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Template9CardStyle.toModifier()
                .fillMaxWidth()
                .margin(top = 32.px)
                .styleModifier { property("height", "calc(100% - 32px)") }
                .backgroundColor(Template9Theme.Card.rgb)
                .border(width = 1.px, style = LineStyle.Solid, color = Template9Theme.Border.rgb)
                .borderRadius(24.px)
                .overflow(Overflow.Hidden)
                .padding(top = 40.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Column(
                modifier = Modifier.padding(leftRight = 20.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                P(
                    attrs = Modifier
                        .margin(top = 6.px, bottom = 8.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .fontWeight(FontWeight.Bold)
                        .textAlign(TextAlign.Center)
                        .color(Template9Theme.Secondary.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(service.title))
                }
                P(
                    attrs = Modifier
                        .margin(top = 0.px, bottom = 20.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontSize(14.px)
                        .lineHeight(1.6)
                        .textAlign(TextAlign.Center)
                        .color(Template9Theme.Text.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(service.description))
                }
            }
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(190.px)
                    .padding(leftRight = 14.px)
            ) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .overflow(Overflow.Hidden)
                        .template9Blob(TEMPLATE9_ARCH)
                ) {
                    AnjurosImage(
                        modifier = Template9ImageZoomStyle.toModifier()
                            .fillMaxSize()
                            .objectFit(ObjectFit.Cover),
                        src = service.image,
                        alt = "Dog walking service"
                    )
                }
                Template9PriceTag(
                    modifier = Modifier
                        .align(Alignment.BottomCenter)
                        .margin(bottom = 8.px)
                        .position(Position.Relative)
                        .zIndex(2),
                    service = service
                )
            }
        }

        Template9IconBadge(
            modifier = Modifier
                .align(Alignment.TopCenter)
                .position(Position.Relative)
                .zIndex(2),
            icon = service.icon,
            alt = "dog walker service icon",
            accent = service.accentIcon,
            size = 64,
            iconSize = 30
        )
    }
}

@Composable
fun Template9ReviewCard(review: Template9Review) {
    Box(
        modifier = Template9CardStyle.toModifier()
            .fillMaxWidth()
            .fillMaxHeight()
            .backgroundColor(Template9Theme.Card.rgb)
            .border(width = 1.px, style = LineStyle.Solid, color = Template9Theme.Border.rgb)
            .borderRadius(20.px)
            .padding(top = 28.px, right = 26.px, bottom = 24.px, left = 26.px)
    ) {
        P(
            attrs = Modifier
                .align(Alignment.TopEnd)
                .margin(top = (-18).px, right = (-6).px, bottom = 0.px, left = 0.px)
                .fontFamily("Georgia", "serif")
                .fontSize(64.px)
                .lineHeight(1)
                .color(Template9Theme.Border.rgb)
                .toAttrs()
        ) {
            Text("”")
        }

        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceBetween
        ) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Row(modifier = Modifier.gap(4.px)) {
                    repeat(5) {
                        Template9StarIcon(color = Template9Theme.Accent.hex, size = 20)
                    }
                }
                P(
                    attrs = Modifier
                        .margin(top = 18.px, bottom = 22.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontSize(15.px)
                        .lineHeight(1.7)
                        .fontStyle(FontStyle.Normal)
                        .textAlign(TextAlign.Center)
                        .color(Template9Theme.Secondary.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(review.review))
                }
            }
            Row(
                modifier = Modifier.gap(12.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                AnjurosImage(
                    modifier = Modifier
                        .size(46.px)
                        .borderRadius(50.percent)
                        .objectFit(ObjectFit.Cover)
                        .border(width = 2.px, style = LineStyle.Solid, color = Template9Theme.Accent.rgb),
                    src = review.image,
                    alt = "Happy dog owner review"
                )
                P(
                    attrs = Modifier
                        .margin(0.px)
                        .fontFamily(Template9Constants.FONT_FAMILY)
                        .fontSize(14.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Template9Theme.Secondary.rgb)
                        .toAttrs()
                ) {
                    Text(LocalText(review.reviewer))
                }
            }
        }
    }
}

@Composable
fun Template9FAQCard(
    faq: Template9FAQ,
    expanded: Boolean,
    onClick: () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Colors.White)
            .border(width = 1.px, style = LineStyle.Solid, color = Template9Theme.Border.rgb)
            .borderRadius(14.px)
            .boxShadow(offsetY = 3.px, blurRadius = 10.px, color = rgba(27, 33, 66, 0.05))
            .overflow(Overflow.Hidden)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .cursor(Cursor.Pointer)
                .padding(leftRight = 22.px, topBottom = 16.px)
                .onClick { onClick() },
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            P(
                attrs = Modifier
                    .margin(top = 0.px, bottom = 0.px, right = 12.px)
                    .fontFamily(Template9Constants.FONT_FAMILY)
                    .fontSize(15.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(Template9Theme.Secondary.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(faq.question))
            }
            P(
                attrs = Modifier
                    .margin(0.px)
                    .fontSize(22.px)
                    .fontWeight(FontWeight.Bold)
                    .lineHeight(1)
                    .color(Template9Theme.Primary.getColor())
                    .rotate(if (expanded) 45.deg else 0.deg)
                    .transition(Transition.of(property = "rotate", duration = 300.ms))
                    .toAttrs()
            ) {
                Text("+")
            }
        }
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .maxHeight(if (expanded) 300.px else 0.px)
                .overflow(Overflow.Hidden)
                .transition(Transition.of(property = "max-height", duration = 400.ms))
        ) {
            P(
                attrs = Modifier
                    .margin(0.px)
                    .padding(left = 22.px, right = 22.px, bottom = 18.px)
                    .fontFamily(Template9Constants.FONT_FAMILY)
                    .fontSize(14.px)
                    .lineHeight(1.7)
                    .color(Template9Theme.Text.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(faq.answer))
            }
        }
    }
}


/** Small white pill with the service price, sitting on the bottom of the service photo. */
@Composable
fun Template9PriceTag(
    service: Template9Service,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier
            .backgroundColor(Template9Theme.Background.rgb)
            .borderRadius(50.px)
            .padding(leftRight = 14.px, topBottom = 6.px)
            .gap(5.px)
            .boxShadow(offsetY = 4.px, blurRadius = 12.px, color = rgba(27, 33, 66, 0.18)),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Span(
            attrs = Modifier
                .fontFamily(Template9Constants.FONT_FAMILY)
                .fontSize(12.px)
                .color(Template9Theme.Text.rgb)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE9_PRICE_FROM))
        }
        Span(
            attrs = Modifier
                .fontFamily(Template9Constants.FONT_FAMILY)
                .fontSize(15.px)
                .fontWeight(FontWeight.Bold)
                .color(Template9Theme.Primary.getColor())
                .toAttrs()
        ) {
            Text("£")
            AnjurosText(service.price, PlaceholderResKey.PLACEHOLDER_SERVICE_PRICE)
        }
        Span(
            attrs = Modifier
                .fontFamily(Template9Constants.FONT_FAMILY)
                .fontSize(12.px)
                .color(Template9Theme.Text.rgb)
                .toAttrs()
        ) {
            Text(LocalText(service.priceUnit))
        }
    }
}
